import(/* webpackMode: "eager", webpackExports: ["AppHomePageSkeleton"] */ "/home/ubuntu/cal-ay/apps/web/app/(use-page-wrapper)/apps/(homepage)/skeleton.tsx");
